import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'
import Node from '@/glxp/abstract/node'

import GEOM from '@/glxp/geom/plane'
import ShaderManifest from '../shaderManifest'
import { vec3 } from 'gl-matrix'
import Emitter from 'event-emitter'


class Plane extends Rendable {
    constructor(scene, shader, texture, options) {
        super(scene)

        this.gl = scene.gl
        this.scene = scene
        this.shaderType = shader
        this.texture = texture

        this.node = new Node()
        this.shader = new Shader(ShaderManifest[shader])

        this.options = options
        /*
        {
          spriteDimension: 5
          speed: 1
        }
        */

       
       this.hasNormal = false
       this.initBuffer({
           vertices: GEOM.vertices,
           uvs: GEOM.uvs,
           indices: GEOM.indices
        })
        
        this.initProgram(this.shader.vert, this.shader.frag)
        this.initVao()
        this.initMatrix()
        this.createUniforms()
        
        this._emitter = {}
        Emitter(this._emitter)
        this.on = this._emitter.on.bind(this._emitter)
        
        this.spawnParams = [-.6, 0, .6]
        this.spawnRate = 3
        this.scale = .5
        this.proxies = []
        this.time = 0
        this.preventSpawn = false

        this.nextSpawn = Math.ceil(Math.random() * this.spawnRate)

    }

    createUniforms() {
        this.createUniform('uTexture', 'texture')
        this.createUniform('uTime')
        if (this.shaderType == "sprite") {
            this.createUniform('uSpriteDim')
        }
    }

    applyState() {
        let gl = this.gl

        this.scene.applyDefaultState()

        gl.disable(gl.CULL_FACE)
        gl.disable(gl.DEPTH_TEST)
        gl.depthMask(false)

    }

    spawnItem(){
        this.nextSpawn = Math.ceil(Math.random() * this.spawnRate)
        if(this.preventSpawn) {return}
        
        let n = new Node()
        n.position = vec3.fromValues(this.spawnParams[Math.floor(Math.random() * this.spawnParams.length)], 3, -30)
        n.scale = vec3.fromValues(this.scale, this.scale, this.scale)
        n.checked = false
        this.node.addChildNode(n)
        this._emitter.emit('spawn', n)
        this.proxies.push(n)
    }

    reset(){
        for (let i = 0; i < this.proxies.length; i++) {
            const p = this.proxies[i];
            this.node.removeChildNode(p)
            this.proxies.splice(i, 1)
        }
        this.nextSpawn = Math.ceil(Math.random() * this.spawnRate)
    }

    preRender() {

        this.time += this.scene.dt / 1000
        if (this.time > this.nextSpawn) {
            this.time = 0
            this.spawnItem()
        }

        for (let i = 0; i < this.proxies.length; i++) {
            const p = this.proxies[i];
            p.position[1] -= this.scene.dt / 500
            p.position[2] += this.scene.dt / 100
            p.needUpdate = true

            if (p.position[2] > -8.75 && p.checked == false) {
                p.checked = true
                let hp = this.scene.hand.node.position[0]
                let pp = p.position[0]
                if ((hp > -0.001 && hp < 0.001) && pp == 0) {
                    // Hit
                    this._emitter.emit('hit', vec3.clone(p.position))
                    this.node.removeChildNode(p)
                    this.proxies.splice(i, 1)
                } else if (hp < -0.001 && pp < 0) {
                    // Hit
                    this._emitter.emit('hit', vec3.clone(p.position))
                    this.node.removeChildNode(p)
                    this.proxies.splice(i, 1)
                } else if (hp > 0.001 && pp > 0) {
                    // Hit
                    this._emitter.emit('hit', vec3.clone(p.position))
                    this.node.removeChildNode(p)
                    this.proxies.splice(i, 1)
                } else {
                    this._emitter.emit('miss', vec3.clone(p.position))   
                }
            }

            if (p.position[2] > 0) {
                this.node.removeChildNode(p)
                this.proxies.splice(i, 1)
            }
            
        }

        // console.log(this.proxies[0].position[2]);
        

    }

    render() {

        this.preRender()

        if (this.proxies.length == 0) {
            return
        }

        let gl = this.gl
        gl.useProgram(this.program)
        gl.bindVertexArray(this.vao)
        this.applyState()

        gl.activeTexture(gl.TEXTURE0)
        gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture(this.texture))
        this.bindUniform('uTexture', 0)
        
        if (this.shaderType == "sprite") {
            this.bindUniform('uSpriteDim', this.options.spriteDimension)
            this.bindUniform('uTime', (this.scene.time * this.options.speed) % this.options.spriteDimension)
        }

        this.bindUniform('uPMatrix', this.scene.camera.getProjectionMatrix())
        this.bindUniform('uVMatrix', this.scene.camera.getViewMatrix())
        for (let i = 0; i < this.proxies.length; i++) {
            const p = this.proxies[i];
            this.bindUniform('uMMatrix', p.getMatrix())
            gl.drawElements(gl.TRIANGLES, GEOM.indices.length, gl.UNSIGNED_SHORT, 0)
        }

        gl.bindVertexArray(null)
    }
}

export default Plane
